<template>
  <div>
    <div class="basicInformation">
        <!-- <el-card>
                <div slot="header">
                    <span>详细信息</span>
                </div>
            <div class="info">
                <el-row>
                    <el-col :span="8">
                        <p>IP地址:</p>
                    </el-col>
                        <el-col :span="8">
                    <p>手机号:</p>
                    </el-col>
                    <el-col :span="8">
                        <p>地址:</p>
                    </el-col>
                    <el-col :span="8">
                        <p>RSSI:</p>
                    </el-col>
                    <el-col :span="8">
                        <p>配置同步状态:</p>
                    </el-col>
                    <el-col :span="8">
                        <p>登录协议:</p>
                    </el-col>
                    <el-col :span="8">
                        <p>IMSI:</p>
                    </el-col>
                    <el-col :span="8">
                        <p>IMEI:</p>
                    </el-col>
                    <el-col :span="8">
                        <p>ICCID:</p>
                    </el-col>
                    <el-col :span="8">
                        <p>硬件版本:</p>
                    </el-col>
                    <el-col :span="8">
                        <p>Bootloader版本:</p>
                    </el-col>
                    <el-col :span="8">
                        <p>上次断开连接原因:</p>
                    </el-col>
                </el-row>
            </div>
        </el-card> -->
        <el-card>
            <div slot="header">
                <span>流量统计</span>
                <el-date-picker
                    style="float: right;"
                    size="mini"
                    v-model="month"
                    type="month"
                    value-format="yyyyMM"
                    placeholder="选择月份"
                    @change = monthChange>
                </el-date-picker>
            </div>
            <div>
                <TrafficStatistics :serialNumber="serialNumber" :month="month"/>
            </div>
        </el-card>
        <el-card class="box-card">
            <div slot="header">
                <span>在线统计</span>
            </div>
            <div>
                <OnlineStatistics :serialNumber="serialNumber"/>
            </div>
        </el-card>
    </div>
  </div>
</template>

<script>
import TrafficStatistics from './TrafficStatistics'
import OnlineStatistics from './OnlineStatistics'
import {utils} from '@/utils/index'
export default {
    name:"gatewayDataDetail",
    components:{
        TrafficStatistics,
        OnlineStatistics
    },
    props:{
        serialNumber:String
    },
    data(){
        return{
            month:''
        }
    },
    methods:{
        monthChange(val){
            console.log(val)
            this.month = val
            console.log(this.month)
        }
    },
    mounted(){
        this.month = utils.formatDate(new Date(),'yyyyMM')
    }
}
</script>

<style lang="scss" scoped>
.basicInformation{
    background-color: rgb(239, 241, 244);
    padding: 20px;
    .box-card{
        margin-top: 20px;
    }
    .info{
        p{
            margin-bottom: 20px;
            font-size: 14px;
        }
    }
}
</style>